module.exports = __webpack_public_path__ + "fonts/NeuePlakTextRegular_normal_normal.97efd44.woff";